import React from 'react';
import { useRankingContext } from '../../Ranking/context/RankingContextProvider';
import Btn from '../../../../Components/Btn';
import { Checkbox } from '../../../../Components/Checkbox/Checkbox';

export default function ProductListActions() {

	const {
		selectedProducts,
		setSelectedProducts,
		addPromotedProductsWithIds,
		addDemotedProductIds,
		addReplaceProductWithIds,
		selectedCategoryIsShopifyCollection
	} = useRankingContext();

	if (!selectedProducts || selectedProducts.length === 0) return <></>;

	return (
		<div className='collection_preview_actions flex'>
			<Checkbox
				forcedChecked={true}
				onChange={() => setSelectedProducts([])}
				labelIsStrong={true}
			>
				{selectedProducts.length}{' '}
				{selectedProducts.length === 1 ? 'selected product' : 'selected products'}
			</Checkbox>
			<div className='btn_switch ml_20'>
				{!selectedCategoryIsShopifyCollection.isPinnableShopifyCollection &&
					<Btn
						message="Promote"
						icon="fas fa-arrow-circle-up"
						onClick={() => addPromotedProductsWithIds(selectedProducts)}
						color="secondary"
						style="outline"
					/>
				}
				<Btn
					message="Demote"
					icon="fas fa-arrow-circle-down"
					onClick={() => addDemotedProductIds(selectedProducts)}
					color="secondary"
					style="outline"
				/>
				<Btn
					message="Swap"
					icon="fas fa-retweet"
					onClick={() => addReplaceProductWithIds(selectedProducts)}
					color="secondary"
					style="outline"
					disabled={selectedProducts.length !== 2}
				/>
			</div>
		</div>
	);
}
